import { encodeTrajectoryDeeplink } from '../../utils/trajectoryDeeplink.js';

export const TRAJECTORY_REQUEST_TYPE = 'evalworkbench:trajectory';
export const MAX_TRAJECTORY_BYTES = 8_000_000;
export const MAX_TRAJECTORY_LINK_LENGTH = 800_000;
const DESTINATION =
  'https://aistudio.teams.core.microsoft/debug?view=trajectory#trajectory=';

export function isTrajectoryRequest(
  value: unknown,
): value is Record<string, unknown> {
  return (
    value !== null &&
    typeof value === 'object' &&
    !Array.isArray(value) &&
    'type' in value &&
    value.type === TRAJECTORY_REQUEST_TYPE
  );
}

export async function buildTrajectoryLink(value: unknown): Promise<string> {
  if (
    !isTrajectoryRequest(value) ||
    Object.keys(value).length !== 3 ||
    value.version !== 1 ||
    typeof value.trajectoryJson !== 'string'
  ) {
    throw new Error('The report sent an unsupported trajectory request.');
  }
  const json = value.trajectoryJson;
  if (
    json.length > MAX_TRAJECTORY_BYTES ||
    new TextEncoder().encode(json).byteLength > MAX_TRAJECTORY_BYTES
  ) {
    throw new Error('The trajectory exceeds the 8,000,000-byte limit.');
  }
  let trajectory: unknown;
  try {
    trajectory = JSON.parse(json);
  } catch (error) {
    if (!(error instanceof SyntaxError)) throw error;
    throw new Error('The report sent invalid trajectory JSON.');
  }
  if (
    trajectory === null ||
    typeof trajectory !== 'object' ||
    Array.isArray(trajectory)
  ) {
    throw new Error('The trajectory must be a JSON object.');
  }
  const encoded = await encodeTrajectoryDeeplink(json);
  if (DESTINATION.length + encoded.length > MAX_TRAJECTORY_LINK_LENGTH) {
    throw new Error('The trajectory link exceeds the 800,000-character limit.');
  }
  return DESTINATION + encoded;
}
